import { resolveEditableTarget } from "./macro-editable-target"
import { getCursorIndexFromRange, setCaret } from "./macro-caret-utils"
import { isTokenChar, resolveTokenContextInText, resolveTokenReplacementRange } from "./macro-token-helpers"

export function buildSelectionSnapshot(target, range) {
    const editable = resolveEditableTarget(target)
    if (!editable) return null
    if (editable.type === "input") return null
    if (!range || !editable.element?.contains(range.startContainer)) return null

    const fullText = editable.element.textContent ?? ""
    const cursorIndex = getCursorIndexFromRange(editable.element, range)
    const context = resolveTokenContextInText(fullText, cursorIndex)
    const nodeText = range.startContainer?.nodeType === Node.TEXT_NODE ? range.startContainer.nodeValue ?? "" : ""
    const nodeCursorIndex = range.startOffset
    const nodeContext = resolveTokenContextInText(nodeText, nodeCursorIndex)

    return {
        fullText,
        cursorIndex,
        context,
        nodeText,
        nodeCursorIndex,
        nodeContext,
    }
}

export function resolveLocalContentEditableReplacement(range, snapshot) {
    if (!range) return null
    if (range.startContainer?.nodeType !== Node.TEXT_NODE) return null
    if (!range.collapsed) return null

    const text = range.startContainer.nodeValue ?? ""
    const offset = range.startOffset
    const context = snapshot?.nodeContext ?? resolveTokenContextInText(text, offset)
    const replacement = resolveTokenReplacementRange(text, offset, context)
    if (!replacement) return null

    let { end } = replacement
    while (end < text.length && isTokenChar(text[end])) end++

    return {
        node: range.startContainer,
        start: replacement.start,
        end,
    }
}

export function applyLocalContentEditableReplacement(range, replacement, token) {
    const { node } = replacement
    const text = node.nodeValue ?? ""
    node.nodeValue = `${text.slice(0, replacement.start)}${token}${text.slice(replacement.end)}`
    setCaret(node, replacement.start + token.length)
}
